module.exports = __webpack_public_path__ + "assets/img/notite.5b2f4043.png";